const Videos = [{
  id: "V3oeREP62Sk",
  title: "Slomoshun making faces",
  startSeconds: 8,
  endSeconds: 11,
  user: 'adamloving'
}, {
  id: "eVB_2T5eF08",
  title: "Wipeout at the Ridge #2",
  startSeconds: (13*60) + 58,
  endSeconds: (14*60) + 9,
  user: 'adamloving'
}, {
  id: '0Yb-VeZop2Y',
  title: 'Taco Training on mercer island',
  startSeconds: 46,
  endSeconds: 52,
  user: 'adamloving'
}, {
  id: 'iB2pNlqAyIY',
  title: 'Winning the Capital Gran Fondo (Medio)',
  startSeconds: (21*60)+40,
  endSeconds: (21*60)+47,
  user: 'adamloving'
}, {
  id: '9WIEH86Lf_4',
  title: 'I owe you one... GO GO!',
  startSeconds: (11*60)+2,
  endSeconds: (11*60)+50
}, {
  title: '“Taco time chasing” (Ballard crit)',
  id: 'Gs0c8ta6x5s',
  startSeconds: (22*60)+9,
  endSeconds: (22*60)+24,
  user: 'adamloving'
}, {
  title: 'Drone footage of Ballard',
  id: 'G9Hsqp6LHMI',
  startSeconds: 0,
  endSeconds: 20,
  user: 'Jim Wallingford'
}, {
  title: 'Go-go-go lead out train',
  id: 'Ds0ERTqUuBw',
  startSeconds: (26*60)+4,
  endSeconds: (26*60)+34,
  user: 'adamloving'
}, {
  id: "AqkYVVixvS4",
  title: "What are you even doing up here?",
  startSeconds: 4,
  endSeconds: 60,
  user: 'adamloving'
}, {
  title: 'Slip-sliding at Volunteer Park',
  id: 'zbktnadeqdo',
  startSeconds: 26,
  endSeconds: 38,
  user: 'adamloving'
}, {
  title: 'Counter-attack leads to break away at PR',
  id: 'inzHiU4ifp4',
  startSeconds: (41*60)+28,
  endSeconds: (42*60)+28,
  user: 'adamloving'
}, {
  title: 'Final lap at Redmond Derby Days',
  id: 'frrLulqUr3g',
  startSeconds: (38*60)+10,
  endSeconds: (39*60)+25,
  user: 'adamloving'
}, {
  title: '3 person break with 2-to-go at PR masters',
  id: 'Pfn6AiM59WQ',
  startSeconds: (47*60) + 25,
  endSeconds: (49*60) + 25,
  user: 'adamloving'
}, {
  title: 'Lap prize at Seward',
  id: '6hxSb-a4a_U',
  startSeconds: (5*60)+22,
  endSeconds: (5*60)+47,
  user: 'adamloving'
}, {
  title: 'Slo mo riding over someone’s head',
  id: 'uHJln8U3psw'
}, {
  title: 'Boston Harbor: Adam on Salam’s camera',
  id: 'nLDA1Ev4rCE',
  startSeconds: (10*60)+37,
  user: 'Salam Hallak'
}, {
  title: 'Boston Harbor bump & crash',
  id: 't7JWOyrQp4E',
  startSeconds: 8,
  user: 'Salam Hallak'
}, {
  title: 'Winding up for 3rd - Boston harbor',
  id: 'oUZIIoPoiGc',
  startSeconds: (60*60)+(22*60)+45,
  endSeconds: (60*60)+(23*60)+47
}, {
  title: '3rd After lead-out Seward',
  id: '9a-u28TdN8M',
  startSeconds: (23*60)+38,
  endSeconds: (24*60)+38
}, {
  title: 'Drone footage at Seward',
  id: 'U82t6naZeYQ',
  startSeconds: (27*60)+1,
  endSeconds: (27*60)+30,
  user: 'Jim Wallingford'
},{
   title: '3rd with momentum Seward',
  id: 'W1CC7EsSqcw',
  startSeconds: (27*60)+1,
  endSeconds: (27*60)+24,
  user: 'adamloving'
}, {
  title: '... another angle',
  id: 'sCXBh0QQEyM',
  user: 'SloMo Shun'
}, {
  title: 'Little wheel rub at PR masters',
  id: '67qFhvU-3Mg',
  startSeconds: (10*60)
}, {
  title: 'Another Race for 3rd at Seward',
  id: 'enLr5sefU50',
  startSeconds: (1*60)+51
}, {
  title: 'Letting in the boogieman...',
  id: 'LrbeQVRyxFA',
  startSeconds: (12*60)+20,
  user: 'TacomaCyclist'
}, {
  title: '… then cutting him off!',
  id: 'LrbeQVRyxFA',
  startSeconds: (13*60)+5,
  user: 'TacomaCyclist'
}, {
  title: 'Tacos on Parade at PR',
  id: '_6HzHenXzuw',
  user: 'SloMo Shun'
}, {
  title: 'Seward finish line',
  id: 'eDV95Kzu99Y',
  user: 'SloMo Shun'
}, {
  title: 'Seward finish line',
  id: 'sYJLF7tuIwA',
  user: 'SloMo Shun'
}, {
  title: 'Seward finish line',
  id: 'QnCD4Ixi2DQ',
  user: 'SloMo Shun'
}]

export default Videos


/** WEBPACK FOOTER **
 ** ./src/videos.js
 **/